<template>
    <div id="learn-two" >
      <div class="learn-two-desktop" v-if="$vuetify.breakpoint.smAndUp">
        <div class="background-learn background-steps z-index-10"></div>
        <img class="absolute decor-one z-index-10" src="@/assets/images/learn/Ellipse 88.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div class="flex absolute information z-index-10" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
          <img class="absolute decor-two" src="@/assets/images/learn/robot_2.png" :class="{sm:$vuetify.breakpoint.sm}">
          <div class="absolute text" :class="{sm:$vuetify.breakpoint.sm}">
            <div class="roboto-bold-48 clr-black">Супер!</div>
            <div class="roboto-normal-24 clr-black mt-xl-5 mt-lg-5 mt-md-5 mt-sm-2">Теперь можно создавать заметки и много чего другого!</div>
            <div class="flex-center">
              <div class="flex-center pointer pt-4 mr-4" @click="toStepThree()">
                <div class="roboto-normal-24 clr-white">Далее</div>
                <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
              </div>
              <LearnSkipButton/>
            </div>
          </div>
        </div>
      </div>
      <div class="learn-two-mobile" v-else>
        <div class="background-learn background-steps z-index-10"></div>
        <img class="absolute decor-one z-index-10" src="@/assets/images/learn/robot_2_mobile.png">
        <img class="absolute decor-two z-index-10" src="@/assets/images/learn/Ellipse 116.png">
        <div class="absolute text z-index-10">
          <div class="roboto-bold-36 clr-black">Супер!</div>
          <div class="roboto-normal-18 clr-black-38 mt-4">Теперь можно создавать заметки и много чего другого!</div>
          <div class="flex-center pointer mt-8 pt-4" @click="toStepThree()">
            <div class="roboto-normal-24 clr-white">Далее</div>
            <v-icon class="ml-1 opacity-max" x-large color="white">mdi-chevron-right</v-icon>
          </div>
          <LearnSkipButton/>
        </div>
      </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
    import {mapGetters, mapMutations} from 'vuex'
import LearnSkipButton from './LearnSkipButton.vue'

    export default Vue.extend({
        props: {
            // item: Object as PropType<Block>,
        },
        components: {
                LearnSkipButton

        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters(['themes']),
        },
        methods: {
        ...mapMutations(['SET_CURRENT_TASK_BY_ROUTE']),
            toStepThree() {
                this.$router.push("/theme/" + this.themes[this.themes.length-1].route_name + "/" + this.themes[this.themes.length-1].tasks[0].route_name + "?learn=3") 
                this.SET_CURRENT_TASK_BY_ROUTE(this.$route.params)
            },
        },
    })

    </script>

<style lang="scss" scoped>
  #learn-two {
    .learn-two-desktop {
      .decor-one {
        top:300px;
        left:52%;
        &.lg {
          left:34%;
        }
        &.md {
          left:14%;
        }
        &.sm {
          left:0%;
          width:590px;
        }
      }
      .information {
        top:400px;
        left:52%;
        &.lg {
          left:34%;
        }
        &.md {
          left:14%;
        }
        &.sm {
          left:5%;
        }
        .decor-two {
          left:35px;
          &.sm {
            top:-20px;
            left:-10px;
            height:178px;
          }
        }
        .text {
          top:35px;
          left:330px;
          width:325px;
          &.sm {
            top:-10px;
            left:200px;
            width:300px;
          }
        }
      }
    }
    .learn-two-mobile {
      .decor-one {
        top:256px;
        left:34%;
      }
      .decor-two {
        top:430px;
        left:-7%;
      }
      .text {
        top:460px;
        left:100px;
        width:225px;
      }
    }
  }
</style>
